import $ from 'jquery';
import { mapState, mapGetters, mapActions } from 'vuex';
import { findIndex } from 'lodash';
import Paginate from 'vuejs-paginate';

import TrackerButton from '@/components/TrackerButton.vue';
import SharedHeader from '@/components/SharedHeader.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Spinner from '@/components/Spinner.vue';
import IMTeamAnnouncementComponent from '@/components/IMTeamAnnouncementComponent.vue';

import { LOADING_MESSAGE, ITEMS_PER_PAGE } from './Message.constants';

// import IMMixin from '@/scripts/IM/IM.js';

export default {
  name: 'Message',
  components: {
    SharedHeader,
    Footer,
    Aside,
    Spinner,
    Paginate,
    WayFindBar,
    TrackerButton,
    IMTeamAnnouncementComponent,
  },
  // mixins: [IMMixin],
  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
      modalMessage: {},
      teamId: '',
    };
  },

  computed: {
    ...mapState('Message', {
      ms_messageCount: 'messageCount',
      ms_messageList: 'messageList',
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      immLoading: 'immLoading',
      imTeamAnnouncementList: 'imTeamAnnouncementList',
    }),

    c_pageCount() {
      return Math.ceil(this.ms_messageCount / ITEMS_PER_PAGE);
    },
  },

  mounted() {
    const _this = this;
    window.popupTeamAnnouncement = (teamId) => {
      _this.teamId = teamId;
      $('#pzClassTeamAnnouncement').modal('show');
      _this._getTeamAnnouncementByTeamId();
    };
    window.showNewMessageFromIM = () => {
      _this.$store.commit('UPDATE_USER_INFO_SUCCESS',
        {
          hasNewMessages: true,
        },
        { root: true });
    }
    window.hideNewMessageFromIM = () => {
      _this.$store.commit('UPDATE_USER_INFO_SUCCESS',
        {
          hasNewMessages: false,
        },
        { root: true });
    }
    // $(`#pzClassTeamAnnouncement`).on('show.bs.modal', async () => {

    // });
  },

  methods: {
    ...mapActions('Message', {
      ma_getMessages: 'getMessages',
      ma_readMessage: 'readMessage',
      ma_readAllMessage: 'readAllMessage',
      getIMToken: 'getIMToken',
    }),

    async _getIMToken() {
      await this.getIMToken();
    },

    async _getTeamAnnouncementByTeamId() {
      console.log(this.teamId);
      await this.$store.dispatch('getIMTeamAnnouncementByTeamId', this.teamId);
    },

    showMessage(message) {
      this.modalMessage = message;
      this.ma_readMessage({ messageId: message.messageId });
    },

    _findMessageIndex() {
      return findIndex(
        this.ms_messageList,
        (message) => this.modalMessage.messageId === message.messageId
      );
    },

    getPrev() {
      let messageIdx = this._findMessageIndex();
      if (0 < messageIdx) {
        messageIdx -= 1;
      }
      this.modalMessage = this.ms_messageList[messageIdx];
      this.ma_readMessage({ messageId: this.ms_messageList[messageIdx].messageId });
    },

    getNext() {
      let messageIdx = this._findMessageIndex();
      if (this.ms_messageList.length - 1 > messageIdx) {
        messageIdx += 1;
      }
      this.modalMessage = this.ms_messageList[messageIdx];
      this.ma_readMessage({ messageId: this.ms_messageList[messageIdx].messageId });
    },

    handlePageChange(pageNum) {
      this.ma_getMessages({
        type: 0,
        pageNo: pageNum,
      });
    },
  },

  created() {
    this.ma_getMessages({
      type: 0,
      pageNo: 1,
    });
    //this._getIMToken();
  },
};
